import React from 'react'
import PropTypes from 'prop-types'
import glamorous from 'glamorous'
import { SuccessSvg } from '../icons/svg-images'
import glamorousIcon from '../icons'
import { withApollo } from 'react-apollo'
import gql from 'graphql-tag'
import { flowRight as compose } from 'lodash'
import { Message } from '@paypalcorp/worldready-react'

const SuccessICON = glamorousIcon({
  '& svg': { height: '30', width: '30' },
})

SuccessICON.defaultProps = { svg: SuccessSvg }

const Button = glamorous.button('vx_btn', {
  minWidth: '70px',
  width: '120px',
  height: '100%',
  borderRadius: '0 5px 5px 0',
  backgroundColor: '#0070ba',
  border: 'solid 3px #0070ba',
  color: '#ffffff',
  fontWeight: '500',
  padding: 0,
})

const Input = glamorous.input({
  border: 'none',
  outline: 'none',
  fontSize: '15px',
  width: '100%',
  color: '#6c7378',
  lineHeight: '1',
  marginTop: '18px',
})

const InputContainer = glamorous.div({
  display: 'flex',
  justifyContent: 'space-between',
  height: '100%',
  position: 'relative',
})

const InputDiv = glamorous.div({
  position: 'relative',
  flex: '1',
  paddingLeft: '12px',
  borderRadius: '5px 0 0 5px',
})

class InputWithBtn extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    title: PropTypes.string,
    inputDefaultValue: PropTypes.string,
    placeholder: PropTypes.string,
    handleBtnClick: PropTypes.func.isRequired,
    customAmount: PropTypes.bool,
    client: PropTypes.object,
    customAmountsWithSku: PropTypes.object,
    suppressErrorMsg: PropTypes.func.isRequired,
    onEnter: PropTypes.func,
    amountError: PropTypes.bool,
    shouldApplyOnBlur: PropTypes.bool,
  }

  state = {
    value: this.props.inputDefaultValue,
  }

  updateInputValue = (e) => {
    this.setState({ value: e.target.value })
    this.props.suppressErrorMsg() // todo: update this method to a more meaningful name
    this.props.onEnter()
    this.props.client.writeData({ data: { checkedCustomAmount: false } })

    if (this.props.customAmount) {
      // once user edit input, reset custom amount, hide the check mark
      this.props.client.writeData({
        data: {
          customAmount: {
            currency_code: this.props.customAmountsWithSku.customAmount
              .minAmount.currency_code,
            value: 0,
          },
        },
      })
    }
  }

  handleClick = (value) => {
    if (this.props.customAmount) {
      const isValid = this.validateAmount(value)
      if (!isValid) {
        // clear input if it's invalid so that user can see the placeholder for min & max amount range
        this.setState({ value: '' })
      }
      // clear error msg
      this.props.suppressErrorMsg()
      this.props.onEnter()

      this.props.client.writeData({ data: { checkedCustomAmount: true } })

      this.props.handleBtnClick(isValid)
    } else {
      this.props.handleBtnClick(value)
    }
  }

  validateAmount = (value) => {
    const {
      customAmountsWithSku: { customAmount },
    } = this.props

    const amountInCent = Number(value) * 100

    if (
      amountInCent >= customAmount.minAmount.value &&
      amountInCent <= customAmount.maxAmount.value &&
      (amountInCent - customAmount.minAmount.value) %
        customAmount.stepPriceAmount ===
        0
    ) {
      const amount = {
        currency_code: customAmount.minAmount.currency_code,
        value: amountInCent,
      }

      // store valid custom input in cache
      this.props.client.writeData({
        data: {
          customAmount: {
            currency_code: amount.currency_code,
            value: amount.value,
          },
        },
      })
      return true
    }
    return false
  }
  renderCheckMark = () => {
    return (
      <span
        id="icon"
        style={{
          position: 'absolute',
          right: '120px',
          paddingTop: '8px',
          paddingRight: '10px',
        }}
      >
        <SuccessICON />
      </span>
    )
  }

  render() {
    let renderCheckmark
    if (this.props.customAmount) {
      const cachedData = this.props.client.readQuery({
        query: gql`
          query getCachedData {
            customAmount @client {
              currency_code
              value
            }
          }
        `,
      })

      if (cachedData.customAmount.value > 0) {
        renderCheckmark = true
      }
    }

    const Label = glamorous.label({
      fontSize: '12px',
      color: this.props.amountError ? '#d20000' : '#0070ba',
      marginBottom: '0',
      height: '15px',
      lineHeight: '1',
      position: 'absolute',
      top: '6px',
    })

    return (
      <InputContainer id={this.props.id}>
        <InputDiv
          id="input-field"
          style={{
            borderLeft: this.props.amountError
              ? 'solid 2px #d20000'
              : 'solid 2px #0070ba',
            borderTop: this.props.amountError
              ? 'solid 2px #d20000'
              : 'solid 2px #0070ba',
            borderBottom: this.props.amountError
              ? 'solid 2px #d20000'
              : 'solid 2px #0070ba',
          }}
        >
          <Label htmlFor={this.props.id}>{this.props.title}</Label>
          <Input
            type="text"
            id="input"
            placeholder={this.props.placeholder}
            value={this.state.value}
            onChange={this.updateInputValue}
            onBlur={() =>
              this.props.shouldApplyOnBlur && this.handleClick(this.state.value)
            }
          />
        </InputDiv>
        {renderCheckmark ? this.renderCheckMark() : null}

        <div>
          <Button onClick={() => this.handleClick(this.state.value)}>
            <Message id="pages/product.product.applyBtn" />
          </Button>
        </div>
      </InputContainer>
    )
  }
}

const InputWithBtnGraphql = compose(withApollo)(InputWithBtn)

export default InputWithBtnGraphql
